import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["collapsable", "collapsableHeader", "toggleComponent"];
  static values = { expanded: Boolean };

  toggleComponent() {
    const chevron = this.toggleComponentTarget.querySelector("svg");
    chevron.classList.toggle("rotate-180", this.expandedValue);
    this.collapsableTarget.classList.toggle("hidden", this.expandedValue);
    this.collapsableHeaderTarget.classList.toggle("rounded-b-xl", this.expandedValue);
    // The container's bottom border belongs to the content div, so while it is hidden the
    // header must draw its own
    this.collapsableHeaderTarget.classList.toggle("border-b-0", !this.expandedValue);

    this.expandedValue = !this.expandedValue;
  }
}
